import { Variation } from '@/@core/services/app.service'
import { TableColumnsType } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Stack,
  Typography,
  Box,
  Chip,
  IconButton,
  Badge,
  Slide
} from '@mui/material'

import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import { useContext } from 'react'
import { AbilityContext } from '@/layouts/components/acl/Can'
import { styled } from '@mui/material/styles'
import CommentOutline from 'mdi-material-ui/CommentOutline'
import { ExternalLinks } from '@/@core/services/api'
import { Circle, CircleHalfFull, MenuDown } from 'mdi-material-ui'
import {
  addCommas,
  calculateOverlapRate,
  chromosomeRegion,
  formatVariantInheritance,
  isJson,
  isWindow,
  renameChildTypes,
  switchVariantClass,
  unique,
  switchACMG
} from '@/@core/utils/utils'
import { useRouter } from 'next/router'
import { Rating } from '@mui/material'

interface Props {
  setCurrent: any
  setOpen: any
  setHistoryOpen: any
  setCommentsOpen: any
  setTranscript_list: any
  handleMenuClick: any
  getColumnSearchProps: any
  setFilterGeneOpen: any
  setMenuType: any
  setFilterGeneData: any
  getFilterGene: any
  setIndexOpen: any
  setGeneIndexOpen: any
  setGeneOpen: any
  setAcmgOpen: any
  setOMIMOpen: any
  setIgvOpen: any
  setIgvLocus: any
  setCnvScipOpen: any
  setCnvAllOpen: any
  setCaseNumberInfoOpen: any
  setClingenOpen: any
  VariationGeneRef: any
  analysisInfo: any
  overlapRate: number
  query: any
}
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  // [`& .${tooltipClasses.tooltip}`]: {
  //   backgroundColor: 'rgba(97, 97, 97)',
  //   color: 'rgb(255, 255, 255)',
  //   maxWidth: 220,
  //   fontSize: theme.typography.pxToRem(12),
  //   border: '1px solid #dadde9'
  // }
}))

const TypographyA = styled(Typography)(() => ({
  fontSize: '0.8rem',
  color: 'inherit'
}))

const Badges = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: '-10px',
    backgroundColor: 'rgb(110,200,229)'
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    maxHeight: 400,
    overflow: 'auto'
  }
})
const chromosome = [
  {
    text: 'chr1',
    value: '1'
  },
  {
    text: 'chr2',
    value: '2'
  },
  {
    text: 'chr3',
    value: '3'
  },
  {
    text: 'chr4',
    value: '4'
  },
  {
    text: 'chr5',
    value: '5'
  },
  {
    text: 'chr6',
    value: '6'
  },
  {
    text: 'chr7',
    value: '7'
  },
  {
    text: 'chr8',
    value: '8'
  },
  {
    text: 'chr9',
    value: '9'
  },
  {
    text: 'chr10',
    value: '10'
  },
  {
    text: 'chr11',
    value: '11'
  },
  {
    text: 'chr12',
    value: '12'
  },
  {
    text: 'chr13',
    value: '13'
  },
  {
    text: 'chr14',
    value: '14'
  },
  {
    text: 'chr15',
    value: '15'
  },
  {
    text: 'chr16',
    value: '16'
  },
  {
    text: 'chr17',
    value: '17'
  },
  {
    text: 'chr18',
    value: '18'
  },
  {
    text: 'chr19',
    value: '19'
  },
  {
    text: 'chr20',
    value: '20'
  },
  {
    text: 'chr21',
    value: '21'
  },
  {
    text: 'chr22',
    value: '22'
  },
  {
    text: 'chrX',
    value: 'X'
  },
  {
    text: 'chrY',
    value: 'Y'
  },
  {
    text: 'chrMT',
    value: 'MT'
  }
]

const color = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgba(229,38,35,0.8)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely pathogenic',
    color: 'rgba(221,109,32,0.8)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(46, 125, 50,0.8)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240,0.4)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200,0.8)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(109,56,149,0.8)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(237, 108, 2,0.8)'
  }
]

const GLScolor = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgb(218,150,148)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely benign',
    color: 'rgb(245,182,193)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(186,204,147)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(64,113,190)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(246,209,139)'
  }
]

export const judgeType = (str: string, arr: any[]) => {
  if (str.includes('child') && !str.includes('//')) {
    return 'C'
  } else if (str.includes('child') && str.includes('//')) {
    return `C${str.split('//')[1]}`
  } else if (str.includes('mother')) {
    return 'M'
  } else if (str.includes('father')) {
    return 'F'
  } else {
    return 'O'
  }
}

const columns2CNV = React.forwardRef((props: Props, ref) => {
  const { t, i18n } = useTranslation()
  const ability = useContext(AbilityContext)

  const router = useRouter()

  const { id, ids, group } = router.query

  const type = router.asPath.includes('/samples') ? 'sample' : 'analyze'

  const overlapRate = React.useMemo(() => {
    return props.overlapRate ?? 0.9
  }, [props.overlapRate])

  const column: TableColumnsType<Variation> = React.useMemo(() => {
    if (props.analysisInfo.pipelineVersion) {
      return [
        {
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Chrom')}
                </span>
              </Stack>
            </Stack>
          ),
          dataIndex: 'chrom',
          key: 'chrom',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'100px'}
                width={'100%'}
                marginTop={'12px'}
                direction="row"
                alignItems="center"
                justifyContent={'space-between'}
              >
                <TypographyA>{row.chrom}</TypographyA>
              </Stack>
            )
          },
          filters: chromosome
        },
        {
          title: () => (
            <Stack
              maxWidth={'100%'}
              justifyContent="start"
              alignItems="center"
              direction={'row'}
            >
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Start')}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('End ')}
                </span>
              </Stack>
            </Stack>
          ),
          dataIndex: 'start',
          key: 'start',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                sx={{
                  cursor: 'pointer'
                }}
                onClick={() => {
                  //
                  props.setIgvOpen(true)

                  props.setCurrent(row)

                  props.setIgvLocus(`chr${row.chrom}:${row.start}-${row.end}`)
                }}
              >
                {row.tempCnvManual && row.tempCnvManual.type ? (
                  <TypographyA>{t('Merge')}</TypographyA>
                ) : (
                  ''
                )}

                <TypographyA
                  sx={{
                    maxWidth: 80,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {row.start}
                </TypographyA>

                <TypographyA
                  sx={{
                    maxWidth: 80,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {row.end}
                </TypographyA>
              </Stack>
            )
          },
          ...props.getColumnSearchProps('start')
        },
        {
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Chromosome arm')}
                </span>
              </Stack>
            </Stack>
          ),
          dataIndex: 'Chromosomearm',
          key: 'Chromosomearm',
          align: 'center',
          width: 120,
          ellipsis: true,
          sorter: false,
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'100px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="center"
              >
                <TypographyA>{row.Chromosomearm}</TypographyA>
              </Stack>
            )
          }
        },
        {
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Copy Number(CN)')}
                </span>
              </Stack>
            </Stack>
          ),
          dataIndex: 'cn',
          key: 'cn',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'100px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="center"
              >
                <TypographyA>{row.cn}</TypographyA>
              </Stack>
            )
          },
          ...props.getColumnSearchProps('CN')
        },
        {
          dataIndex: 'sv_type',
          key: 'sv_type',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Type')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
              >
                <TypographyA>{row.sv_type}</TypographyA>
              </Stack>
            )
          },
          filters: [
            {
              value: 'DEL',
              text: i18n.language === 'zh' ? `DEL(${t('del')})` : 'DEL'
            },
            {
              value: 'DUP',
              text: i18n.language === 'zh' ? `DUP(${t('dup')})` : 'DUP'
            },
            {
              value: 'INS',
              text: i18n.language === 'zh' ? `INS(${t('ins')})` : 'INS'
            },
            {
              value: 'INV',
              text: i18n.language === 'zh' ? `INV(${t('inv')})` : 'INV'
            },
            {
              value: 'BND',
              text: i18n.language === 'zh' ? `BND(${t('bnd')})` : 'BND'
            }
          ]
        },
        {
          dataIndex: 'gene',
          key: 'gene',
          align: 'center',
          width: 160,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Tooltip title={'下拉箭头查看基因详情'}>
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('Gene')}
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value: any, row: any) => {
            const gene = row?.gene
            const scip_gene_info_data = row?.scip_gene_info ?? []

            return (
              <Stack
                sx={{
                  position: 'relative'
                }}
                maxWidth={'160px'}
                direction="row"
                alignItems="center"
                justifyContent={'space-between'}
              >
                <Stack
                  maxWidth={'130px'}
                  width={'100%'}
                  marginTop={'12px'}
                  direction="column"
                  alignItems="start"
                  sx={{
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    props.setCnvAllOpen(true)

                    props.setCurrent(row)
                  }}
                >
                  <Tooltip title={`${gene}`} placement="top-start">
                    <TypographyA
                      sx={{
                        width: '100%',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        wordBreak: 'break-all',
                        fontWeight: 500
                      }}
                    >
                      {gene ? (
                        <>
                          <span>{`${gene}`}</span>
                        </>
                      ) : null}
                    </TypographyA>
                  </Tooltip>
                </Stack>

                {scip_gene_info_data.length ? (
                  <IconButton
                    onClick={(e) => {
                      props.setCurrent(row)

                      props.handleMenuClick &&
                        props.handleMenuClick(e, 'scip_gene')
                    }}
                    sx={{
                      color: 'inherit',
                      padding: 0

                      // position: 'absolute',
                      // right: 0,
                      // bottom: '-1rem'
                    }}
                    size="small"
                  >
                    <MenuDown />
                  </IconButton>
                ) : (
                  ''
                )}
              </Stack>
            )
          },
          ...props.getColumnSearchProps('gene')
        },
        {
          dataIndex: 'score_details',
          key: 'score_details',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {`${t('ACMG evidences')}(Annotsv)`}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {`ACMG ${t('score')}`}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Length (bp)')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                justifyContent={'center'}
              >
                <TypographyA>{row.score_details}</TypographyA>

                <TypographyA>{row.total_score}</TypographyA>

                <TypographyA
                  sx={{
                    maxWidth: 80,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {typeof row.sv_length === 'number'
                    ? Math.round(row.sv_length)
                    : row.sv_length}
                </TypographyA>
              </Stack>
            )
          }
        },
        {
          dataIndex: 'ccnv_priority',
          key: 'ccnv_priority',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Tooltip title={'双软件注释(classifyCNV、annotsv)'}>
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('ACMG')}
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value: any, row: any) => {
            const classification = row.classification
            const flag =
              (classification === 'LP' || classification === 'PAT') &&
              classification !== row.ccnv_classification

            //

            const bgcolor = GLScolor.find(
              (i) =>
                i.key === switchACMG(row.ccnv_classification)?.toLowerCase()
            )
              ? (color.find(
                  (i) =>
                    i.key === switchACMG(row.ccnv_classification)?.toLowerCase()
                )?.color as
                  | 'rgb(240,239,240,0.4)'
                  | 'rgba(221,109,32,0.8)'
                  | 'rgb(255,242,202)'
                  | 'rgb(245,182,193)')
              : 'rgba(0, 0, 0)'

            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="row"
                alignItems="center"
                justifyContent={'center'}
              >
                {row.ccnv_classification && row.ccnv_classification != '.' ? (
                  <Chip
                    sx={{
                      bgcolor: bgcolor,
                      color:
                        bgcolor === 'rgb(240,239,240,0.4)' ? 'black' : 'white',
                      justifyContent: 'start',
                      fontSize: '0.75rem'
                    }}
                    label={`${row.ccnv_classification}`}
                    onClick={() => {
                      props.setCurrent(row)

                      props.setCnvScipOpen(true)
                    }}
                    size="small"
                  />
                ) : (
                  row.ccnv_classification
                )}

                {flag ? (
                  <Tooltip
                    placement="top-start"
                    title={`AnnotSV:${classification}`}
                  >
                    <Box
                      sx={{
                        width: '10px',
                        height: '10px',
                        bgcolor: 'red',
                        borderRadius: '50%',
                        display: 'inline-block'
                      }}
                    ></Box>
                  </Tooltip>
                ) : (
                  ''
                )}
              </Stack>
            )
          },
          filters: [
            {
              value: 'Pathogenic',
              text: 'Pathogenic'
            },
            {
              value: 'Likely pathogenic',
              text: 'Likely Pathogenic'
            },
            {
              value: 'Uncertain significance',
              text: 'Uncertain Significance'
            },
            {
              value: 'Likely benign',
              text: 'Likely Benign'
            },
            {
              value: 'Benign',
              text: 'Benign'
            }
          ]
        },
        {
          dataIndex: 'scip_highlights_data',
          key: 'scip_highlights_data',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Tooltip title={'良性信息(如高人群频率等)'}>
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('负面信息情况')}
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
              >
                <TypographyA>
                  {row?.scip_highlights_data?.negative?.filter(
                    (i: string) => !i.includes('没有异常读取')
                  ).length
                    ? t('true')
                    : t('false')}
                </TypographyA>
              </Stack>
            )
          },
          ...props.getColumnSearchProps('scip_Highlights')
        },
        {
          dataIndex: 'inheritance',
          key: 'inheritance',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="center" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('OMIM')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value: any, row: any) => {
            const omim_genes = row.omim_genes ?? []
            const omim_curate_phenotypes = omim_genes
              .map((i: any) => i?.omim_curate_phenotypes)
              .flat()
            const omim_phenotypes = omim_genes
              .map((i: any) => i?.omim_phenotypes)
              .flat()
            if (
              i18n &&
              i18n.language === 'zh' &&
              omim_curate_phenotypes &&
              omim_curate_phenotypes.length
            ) {
              let OMIMValue = omim_curate_phenotypes

              OMIMValue = unique(OMIMValue, 'disease')

              let bgcolor = color.find(
                (i) => i.key === row.gls_classification?.toLowerCase()
              )
                ? (color.find(
                    (i) => i.key === row.gls_classification?.toLowerCase()
                  )?.color as any)
                : 'rgba(0, 0, 0)'

              // loss_of_function等于1 并且gls_classification不等于P/LP
              if (row.gls_classification?.toLowerCase() === 'pathogenic') {
                //
              } else if (
                row.gls_classification?.toLowerCase() === 'likely pathogenic'
              ) {
                //
              } else if (row.loss_of_function === 1) bgcolor = '#f5d18c'

              return (
                <Stack maxWidth={'100%'} spacing={1}>
                  {OMIMValue && OMIMValue.length ? (
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          {OMIMValue.map((item: any, index: any) => (
                            <TypographyA
                              sx={{
                                fontSize: '0.85rem',
                                lineHeight: '1rem',
                                maxWidth: isWindow()
                                  ? '400px !important'
                                  : '200px !important'
                              }}
                              key={`${item.disease}_${index}`}
                            >
                              {`(${
                                item.genetic_mode ? item.genetic_mode : '.'
                              })-${
                                i18n && i18n.language === 'zh'
                                  ? item.disease
                                  : ''
                              }`}
                            </TypographyA>
                          ))}
                        </React.Fragment>
                      }
                      placement={'top-start'}
                      TransitionComponent={Slide}
                      sx={{
                        '& .MuiTooltip-tooltip': {
                          maxWidth: isWindow() ? '400px' : '200px'
                        }
                      }}
                    >
                      <Box>
                        {OMIMValue.slice(0, 2).map((items: any, index: any) => {
                          return (
                            <TypographyA
                              sx={{
                                width: '100%',
                                maxWidth: 200,
                                lineHeight: '24px',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                cursor: 'pointer',
                                color:
                                  bgcolor === 'rgb(109,56,149,0.8)' ||
                                  bgcolor === 'rgb(107,148,200,0.8)' ||
                                  bgcolor === 'rgba(229,38,35,0.8)'
                                    ? 'white'
                                    : '#23527c',
                                mb: '4px'
                              }}
                              onClick={() => {
                                props.setCurrent({
                                  ...row,
                                  omim_curate_phenotypes,
                                  omim_phenotypes
                                })

                                props.setOMIMOpen(true)
                              }}
                              key={`${items.disease}_${index}`}
                            >
                              <Chip
                                label={`${
                                  items.genetic_mode ? items.genetic_mode : '.'
                                }`}
                                size="small"
                                sx={{
                                  height: 18,
                                  fontSize: '0.75rem',
                                  fontWeight: '700'
                                }}
                              />

                              <span
                                style={{
                                  lineHeight: '24px'
                                }}
                              >{`${
                                i18n && i18n.language === 'zh'
                                  ? items.disease + '-'
                                  : ''
                              }${items.disease}`}</span>
                            </TypographyA>
                          )
                        })}

                        {/* {OMIMValue.length > 3 ? '...' : ''} */}
                      </Box>
                    </HtmlTooltip>
                  ) : (
                    <TypographyA>.</TypographyA>
                  )}
                </Stack>
              )
            } else {
              let OMIMValue =
                omim_phenotypes?.map((item: any) => {
                  const inheritances: string[] = []
                  const clinicalSynopsis = isJson(item.clinicalSynopsis)
                    ? JSON.parse(item.clinicalSynopsis)
                    : item.clinicalSynopsis

                  if (
                    item &&
                    clinicalSynopsis &&
                    clinicalSynopsis.INHERITANCE &&
                    Array.isArray(clinicalSynopsis.INHERITANCE)
                  ) {
                    clinicalSynopsis.INHERITANCE.forEach((str: string) =>
                      inheritances.push(str.toLowerCase())
                    )
                  }
                  const inheritance = formatVariantInheritance(
                    Array.from([...new Set(inheritances)]).join(',')
                  )

                  return {
                    ...item,
                    inheritance
                  }
                }) ?? []

              OMIMValue = unique(OMIMValue, 'phenoName')

              let bgcolor = color.find(
                (i) => i.key === row.gls_classification?.toLowerCase()
              )
                ? (color.find(
                    (i) => i.key === row.gls_classification?.toLowerCase()
                  )?.color as any)
                : 'rgba(0, 0, 0)'

              // loss_of_function等于1 并且gls_classification不等于P/LP
              if (row.gls_classification?.toLowerCase() === 'pathogenic') {
                //
              } else if (
                row.gls_classification?.toLowerCase() === 'likely pathogenic'
              ) {
                //
              } else if (row.loss_of_function === 1) bgcolor = '#f5d18c'

              return (
                <Stack maxWidth={'100%'} spacing={1}>
                  {OMIMValue && OMIMValue.length ? (
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          {OMIMValue.map((item: any, index: number) => (
                            <TypographyA
                              sx={{
                                fontSize: '0.85rem',
                                lineHeight: '1rem',
                                maxWidth: isWindow()
                                  ? '400px !important'
                                  : '200px !important'
                              }}
                              key={`${item.phenoName}_${index}`}
                            >
                              {`(${
                                item.inheritance ? item.inheritance : '.'
                              })-${
                                i18n && i18n.language === 'zh'
                                  ? item.pheno_name_cn + '-'
                                  : ''
                              }${item.phenoName}`}
                            </TypographyA>
                          ))}
                        </React.Fragment>
                      }
                      placement={'top-start'}
                      TransitionComponent={Slide}
                      sx={{
                        '& .MuiTooltip-tooltip': {
                          maxWidth: isWindow() ? '400px' : '200px'
                        }
                      }}
                    >
                      <Box>
                        {OMIMValue.slice(0, 2).map(
                          (items: any, index: number) => {
                            return (
                              <TypographyA
                                sx={{
                                  width: '100%',
                                  maxWidth: 200,
                                  lineHeight: '24px',
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  textOverflow: 'ellipsis',
                                  cursor: 'pointer',
                                  color:
                                    bgcolor === 'rgb(109,56,149,0.8)' ||
                                    bgcolor === 'rgb(107,148,200,0.8)' ||
                                    bgcolor === 'rgba(229,38,35,0.8)'
                                      ? 'white'
                                      : '#23527c',
                                  mb: '4px'
                                }}
                                onClick={() => {
                                  props.setCurrent({
                                    ...row,
                                    omim_curate_phenotypes,
                                    omim_phenotypes
                                  })

                                  props.setOMIMOpen(true)
                                }}
                                key={`${items.phenoMim}_${index}`}
                              >
                                <Chip
                                  label={`${
                                    items.inheritance ? items.inheritance : '.'
                                  }`}
                                  size="small"
                                  sx={{
                                    height: 18,
                                    fontSize: '0.75rem',
                                    fontWeight: '700'
                                  }}
                                />

                                <span
                                  style={{
                                    lineHeight: '24px'
                                  }}
                                >{`${
                                  i18n && i18n.language === 'zh'
                                    ? items.pheno_name_cn + '-'
                                    : ''
                                }${items.phenoName}`}</span>
                              </TypographyA>
                            )
                          }
                        )}

                        {/* {OMIMValue.length > 3 ? '...' : ''} */}
                      </Box>
                    </HtmlTooltip>
                  ) : (
                    <TypographyA>.</TypographyA>
                  )}
                </Stack>
              )
            }
          },
          ...props.getColumnSearchProps('inheritance')
        },
        {
          dataIndex: 'scip_summary_priority',
          key: 'scip_summary_priority',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Tooltip title={'根据变异质量排序'}>
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('优先级')}
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
              >
                <TypographyA>{row?.scip_summary_priority}</TypographyA>
              </Stack>
            )
          }
        },
        {
          dataIndex: 'scip_summary_auto_result',
          key: 'scip_summary_auto_result',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Tooltip
                title={
                  <Box>
                    <Typography color={'white'} fontSize={12}>
                      质量:变异质量分级
                    </Typography>

                    <Typography color={'white'} fontSize={12}>
                      映射质量:变异质量评估参数，通常大于50
                    </Typography>

                    <Typography color={'white'} fontSize={12}>
                      深度比:目标区域与参考区域深度对比
                    </Typography>
                  </Box>
                }
              >
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {`${t('质量')}`}
                  </span>

                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {`${t('映射质量')}`}
                  </span>

                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('深度比')}
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                justifyContent={'center'}
              >
                <TypographyA>{row.scip_summary_auto_result}</TypographyA>

                <TypographyA>{row.scip_summary_mapping_quality}</TypographyA>

                <TypographyA>{row.scip_summary_depth_ratio}</TypographyA>
              </Stack>
            )
          }
        },

        {
          dataIndex: 'sv_count',
          key: 'sv_count',
          align: 'center',
          width: 100,
          ellipsis: true,
          sorter: false,
          filteredValue: [`${overlapRate}`],
          title: () => (
            <Stack
              maxWidth={'100%'}
              justifyContent="start"
              direction={'column'}
            >
              <Tooltip
                title={
                  'The overlap rate of different databases can be calculated, and the overlap rate can be adjusted personalized'
                }
              >
                <>
                  <Stack maxWidth={'100%'}>
                    <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                      {`${t('The overlap rate is over')}${
                        (overlapRate ?? 0.9) * 100
                      }%`}
                    </span>
                  </Stack>

                  <Stack maxWidth={'100%'}>
                    <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                      {`${t('Number of cases')}`}
                    </span>
                  </Stack>
                </>
              </Tooltip>
            </Stack>
          ),
          render: (value: any, row: any) => {
            const scip_gnomad_sv_data = row?.scip_gnomad_sv_data
            const scip_clinvar_sv_data = row?.scip_clinvar_sv_data
            const decipherCnvInfo =
              row?.tempCnvDecipherInfo?.decipherInfo?.decipherCnvInfo
            const decipherSyndromeInfo =
              row?.tempCnvDecipherInfo?.decipherInfo?.decipherSyndromeInfo
            const decipherPopulationInfo =
              row?.tempCnvDecipherInfo?.decipherInfo?.decipherPopulationInfo
            const decipherDgvInfo =
              row?.tempCnvDecipherInfo?.decipherInfo?.decipherDgvInfo

            // const gnomads =
            //   scip_gnomad_sv_data && Array.isArray(scip_gnomad_sv_data)
            //     ? [...scip_gnomad_sv_data].filter(
            //         (i) => i && i.overlap_rate && i.overlap_rate >= 0.9
            //       )
            //     : []
            // const gnomadscount = gnomads?.length
            // const clinvars =
            //   scip_clinvar_sv_data && Array.isArray(scip_clinvar_sv_data)
            //     ? [...scip_clinvar_sv_data].filter(
            //         (i) => i && i.overlap_rate && i.overlap_rate >= 0.9
            //       )
            //     : []
            // const clinvarscount = clinvars?.length
            const gnomad =
              decipherPopulationInfo && Array.isArray(decipherPopulationInfo)
                ? [...decipherPopulationInfo]
                    .filter(
                      (i) => switchVariantClass(i.variant_class) === row.sv_type
                    )
                    .map((i) => {
                      i.Coverage = calculateOverlapRate(
                        row.start,
                        row.end,
                        i.start,
                        i.end
                      )

                      return i
                    })
                    .filter((i) => i && i.Coverage && i.Coverage >= 0.9)
                : []

            const gnomadscount = gnomad?.length
            const clinvar =
              decipherSyndromeInfo && Array.isArray(decipherSyndromeInfo)
                ? [...decipherSyndromeInfo]
                    .filter(
                      (i) => switchVariantClass(i.variant_class) === row.sv_type
                    )
                    .map((i) => {
                      i.Coverage = calculateOverlapRate(
                        row.start,
                        row.end,
                        i.start,
                        i.end
                      )

                      return i
                    })
                    .filter((i) => i && i.Coverage && i.Coverage >= 0.9)
                : []

            const clinvarscount = clinvar?.length
            const decipher =
              decipherCnvInfo && Array.isArray(decipherCnvInfo)
                ? [...decipherCnvInfo]
                    .filter(
                      (i) => switchVariantClass(i.variant_class) === row.sv_type
                    )
                    .map((i) => {
                      i.Coverage = calculateOverlapRate(
                        row.start,
                        row.end,
                        i.start,
                        i.end
                      )

                      return i
                    })
                    .filter((i) => i && i.Coverage && i.Coverage >= 0.9)
                : []

            const deciphercount = decipher?.length
            const dgv =
              decipherDgvInfo && Array.isArray(decipherDgvInfo)
                ? [...decipherDgvInfo]
                    .filter(
                      (i) => switchVariantClass(i.variant_class) === row.sv_type
                    )
                    .map((i) => {
                      i.Coverage = calculateOverlapRate(
                        row.start,
                        row.end,
                        i.start,
                        i.end
                      )

                      return i
                    })
                    .filter((i) => i && i.Coverage && i.Coverage >= 0.9)
                : []

            const dgvcount = dgv?.length

            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                justifyContent={'center'}
                spacing={1}
                sx={{
                  cursor: 'pointer'
                }}
                onClick={() => {
                  props.setCurrent({
                    ...row,
                    gnomads: gnomad,
                    clinvars: clinvar,
                    decipherCnvInfos: decipher,
                    decipherDgvInfos: dgv
                  })

                  props.setCaseNumberInfoOpen &&
                    props.setCaseNumberInfoOpen(true)
                }}
              >
                <TypographyA>{`gnomad:${gnomadscount}`}</TypographyA>

                <TypographyA>{`clinvar:${clinvarscount}`}</TypographyA>

                <TypographyA>{`decipher:${deciphercount}`}</TypographyA>

                <TypographyA>{`dgv:${dgvcount}`}</TypographyA>
              </Stack>
            )
          },

          filters: [
            {
              text: '95%',
              value: '0.95'
            },
            {
              text: '90%',
              value: '0.9'
            },
            {
              text: '85%',
              value: '0.85'
            },
            {
              text: '80%',
              value: '0.8'
            },
            {
              text: '70%',
              value: '0.7'
            }
          ]
        },
        {
          dataIndex: 'scip_clingen_sv_data',
          key: 'scip_clingen_sv_data',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Tooltip title={'clingen数据库特殊区域描述'}>
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {`${t('clingen')}`}
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value: any, row: any) => {
            const scip_clinical_genome_data: any[] =
              row.scip_clinical_genome_data ?? []

            return (
              <Tooltip
                title={scip_clinical_genome_data
                  .map((i) => `${i.dosageId}(${i.hgncId})`)
                  .join(';')}
              >
                <TypographyA
                  onClick={(e) => {
                    props.setCurrent(row)

                    // props.handleMenuClick(e, 'scip_clingen')

                    props.setClingenOpen(true)
                  }}
                  sx={{
                    maxWidth: 100,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    cursor: 'pointer'
                  }}
                >
                  {scip_clinical_genome_data
                    .map((i) => `${i.dosageId}(${i.hgncId})`)
                    .join(';')}
                </TypographyA>
              </Tooltip>
            )
          },
          ...props.getColumnSearchProps('scip_Clingen')
        }
      ]
    } else {
      return [
        {
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Chrom')}
                </span>
              </Stack>
            </Stack>
          ),
          dataIndex: 'chrom',
          key: 'chrom',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'100px'}
                width={'100%'}
                marginTop={'12px'}
                direction="row"
                alignItems="center"
                justifyContent={'space-between'}
              >
                <TypographyA>{row.chrom}</TypographyA>
              </Stack>
            )
          },
          filters: chromosome
        },
        {
          title: () => (
            <Stack
              maxWidth={'100%'}
              justifyContent="start"
              alignItems="center"
              direction={'row'}
            >
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Start')}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('End ')}
                </span>
              </Stack>
            </Stack>
          ),
          dataIndex: 'SV_start',
          key: 'SV_start',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                sx={{
                  cursor: 'pointer'
                }}
                onClick={() => {
                  //
                  props.setIgvOpen(true)

                  props.setCurrent(row)

                  props.setIgvLocus(
                    `chr${row.chrom}:${row.SV_start}-${row.SV_end}`
                  )
                }}
              >
                {row.tempCnvManual && row.tempCnvManual.type ? (
                  <TypographyA>{t('Merge')}</TypographyA>
                ) : (
                  ''
                )}

                <TypographyA
                  sx={{
                    maxWidth: 80,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {row.SV_start}
                </TypographyA>

                <TypographyA
                  sx={{
                    maxWidth: 80,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {row.SV_end}
                </TypographyA>
              </Stack>
            )
          },
          ...props.getColumnSearchProps('start')
        },
        {
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Chromosome arm')}
                </span>
              </Stack>
            </Stack>
          ),
          dataIndex: 'Chromosomearm',
          key: 'Chromosomearm',
          align: 'center',
          width: 120,
          ellipsis: true,
          sorter: true,
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'100px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="center"
              >
                <TypographyA>{row.Chromosomearm}</TypographyA>
              </Stack>
            )
          }
        },
        {
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Copy Number(CN)')}
                </span>
              </Stack>
            </Stack>
          ),
          dataIndex: 'CN',
          key: 'CN',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'100px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="center"
              >
                <TypographyA>{row.CN}</TypographyA>
              </Stack>
            )
          },
          ...props.getColumnSearchProps('CN')
        },
        {
          dataIndex: 'SVType',
          key: 'SVType',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Type')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
              >
                <TypographyA>{row.SV_type}</TypographyA>
              </Stack>
            )
          },
          filters: [
            {
              value: 'DEL',
              text: i18n.language === 'zh' ? `DEL(${t('del')})` : 'DEL'
            },
            {
              value: 'DUP',
              text: i18n.language === 'zh' ? `DUP(${t('dup')})` : 'DUP'
            },
            {
              value: 'INS',
              text: i18n.language === 'zh' ? `INS(${t('ins')})` : 'INS'
            },
            {
              value: 'INV',
              text: i18n.language === 'zh' ? `INV(${t('inv')})` : 'INV'
            },
            {
              value: 'BND',
              text: i18n.language === 'zh' ? `BND(${t('bnd')})` : 'BND'
            }
          ]
        },
        {
          dataIndex: 'gene',
          key: 'gene',
          align: 'center',
          width: 160,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Tooltip title={'下拉箭头查看基因详情'}>
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('Gene')}
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value: any, row: any) => {
            const scip_gene_info_data = row.scip_gene_info_data ?? []
            const omim_genes = row.ExomeDepth_omim_genes?.join(';')
            const omim_disease_genes = row.gene_info?.omim_disease_genes
              .map((item: any) => {
                return `${item.symbol}`
              })
              .join(';')
            const other_genes = row.gene_info?.other_genes
              ?.map((item: any) => {
                return `${item}`
              })
              .join(';')

            return (
              <Stack
                sx={{
                  position: 'relative'
                }}
                maxWidth={'160px'}
                direction="row"
                alignItems="center"
                justifyContent={'space-between'}
              >
                <Stack
                  maxWidth={'130px'}
                  width={'100%'}
                  marginTop={'12px'}
                  direction="column"
                  alignItems="start"
                  sx={{
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    props.setCnvAllOpen(true)

                    props.setCurrent(row)
                  }}
                >
                  <Tooltip
                    title={`${omim_disease_genes}`}
                    placement="top-start"
                  >
                    <TypographyA
                      sx={{
                        width: '100%',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        wordBreak: 'break-all',
                        fontWeight: 500
                      }}
                    >
                      {omim_disease_genes ? (
                        <>
                          <span
                            style={{
                              color: 'red'
                            }}
                          >{`${omim_disease_genes}`}</span>
                        </>
                      ) : null}
                    </TypographyA>
                  </Tooltip>

                  <Tooltip title={other_genes} placement="top-start">
                    <TypographyA
                      sx={{
                        width: '100%',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        wordBreak: 'break-all',
                        fontWeight: 500
                      }}
                    >
                      {other_genes ? (
                        <>
                          <span>{`${other_genes}`}</span>
                        </>
                      ) : null}
                    </TypographyA>
                  </Tooltip>
                </Stack>

                {scip_gene_info_data.length ? (
                  <IconButton
                    onClick={(e) => {
                      props.setCurrent(row)

                      props.handleMenuClick(e, 'scip_gene')
                    }}
                    sx={{
                      color: 'inherit',
                      padding: 0

                      // position: 'absolute',
                      // right: 0,
                      // bottom: '-1rem'
                    }}
                    size="small"
                  >
                    <MenuDown />
                  </IconButton>
                ) : (
                  ''
                )}
              </Stack>
            )
          },
          ...props.getColumnSearchProps('gene')
        },
        {
          dataIndex: 'ClassifyCNV_evidences',
          key: 'ClassifyCNV_evidences',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {`${t('ACMG evidences')}(Annotsv)`}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {`ACMG ${t('score')}`}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Length (bp)')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                justifyContent={'center'}
              >
                <TypographyA>{row.AnnotSV_evidences}</TypographyA>

                <TypographyA>{row.total_score}</TypographyA>

                <TypographyA
                  sx={{
                    maxWidth: 80,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {typeof row.LEN === 'number' ? Math.round(row.LEN) : row.LEN}
                </TypographyA>
              </Stack>
            )
          }
        },
        {
          dataIndex: 'ccnv_priority',
          key: 'ccnv_priority',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Tooltip title={'双软件注释(classifyCNV、annotsv)'}>
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('ACMG')}
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value: any, row: any) => {
            const classification = row.classification
            const flag =
              (classification?.toLowerCase() === 'likely pathogenic' ||
                classification?.toLowerCase() === 'pathogenic') &&
              classification !== row.ccnv_classification

            //

            const bgcolor = GLScolor.find(
              (i) => i.key === row.ccnv_classification?.toLowerCase()
            )
              ? (color.find(
                  (i) => i.key === row.ccnv_classification?.toLowerCase()
                )?.color as
                  | 'rgb(240,239,240,0.4)'
                  | 'rgba(221,109,32,0.8)'
                  | 'rgb(255,242,202)'
                  | 'rgb(245,182,193)')
              : 'rgba(0, 0, 0)'

            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="row"
                alignItems="center"
                justifyContent={'center'}
              >
                {row.ccnv_classification && row.ccnv_classification != '.' ? (
                  <Chip
                    sx={{
                      bgcolor: bgcolor,
                      color:
                        bgcolor === 'rgb(240,239,240,0.4)' ? 'black' : 'white',
                      justifyContent: 'start',
                      fontSize: '0.75rem'
                    }}
                    label={`${
                      row.ccnv_classification && row.ccnv_classification != '.'
                        ? row.ccnv_classification
                            .split(' ')
                            .map((word: any) => {
                              if (word.includes('Uncertain')) return `VU`
                              if (word.includes('null')) return ``
                              else return word[0].toUpperCase()
                            })
                            .join('')
                        : '.'
                    }`}
                    onClick={() => {
                      props.setCurrent(row)

                      props.setCnvScipOpen(true)
                    }}
                    size="small"
                  />
                ) : (
                  row.ccnv_classification
                )}

                {flag ? (
                  <Tooltip
                    placement="top-start"
                    title={`AnnotSV:${classification}`}
                  >
                    <Box
                      sx={{
                        width: '10px',
                        height: '10px',
                        bgcolor: 'red',
                        borderRadius: '50%',
                        display: 'inline-block'
                      }}
                    ></Box>
                  </Tooltip>
                ) : (
                  ''
                )}
              </Stack>
            )
          },
          filters: [
            {
              value: 'Pathogenic',
              text: 'Pathogenic'
            },
            {
              value: 'Likely pathogenic',
              text: 'Likely Pathogenic'
            },
            {
              value: 'Uncertain significance',
              text: 'Uncertain Significance'
            },
            {
              value: 'Likely benign',
              text: 'Likely Benign'
            },
            {
              value: 'Benign',
              text: 'Benign'
            }
          ]
        },
        {
          dataIndex: 'scip_highlights_data',
          key: 'scip_highlights_data',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Tooltip title={'良性信息(如高人群频率等)'}>
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('负面信息情况')}
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
              >
                <TypographyA>
                  {row?.scip_highlights_data?.negative?.filter(
                    (i: string) => !i.includes('没有异常读取')
                  ).length
                    ? t('true')
                    : t('false')}
                </TypographyA>
              </Stack>
            )
          },
          ...props.getColumnSearchProps('scip_Highlights')
        },
        {
          dataIndex: 'inheritance',
          key: 'inheritance',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="center" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('OMIM')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value: any, row: any) => {
            const omim_info = row.omim_info

            const bgcolor = color.find(
              (i) => i.key === row.ccnv_classification?.toLowerCase()
            )
              ? (color.find(
                  (i) => i.key === row.ccnv_classification?.toLowerCase()
                )?.color as any)
              : 'rgba(0, 0, 0)'

            if (
              row.OMIMArr &&
              row.OMIMArr.length &&
              row.OMIMArr.some(
                (item: any) => item?.geneDiseaseTranslated?.data
              ) &&
              i18n &&
              i18n.language === 'zh'
            ) {
              const OMIMValue =
                row.OMIMArr.map(
                  (items: any) => items?.geneDiseaseTranslated?.data ?? []
                ).flat() ?? []

              return (
                <Stack maxWidth={'100%'} spacing={1}>
                  {OMIMValue && OMIMValue.length ? (
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          {OMIMValue.map((item: any, index: any) => (
                            <TypographyA
                              sx={{
                                fontSize: '0.85rem',
                                lineHeight: '1rem',
                                maxWidth: isWindow()
                                  ? '400px !important'
                                  : '200px !important'
                              }}
                              key={`${item.disease}_${index}`}
                            >
                              {`(${
                                item.genetic_mode ? item.genetic_mode : '.'
                              })-${item.disease}`}
                            </TypographyA>
                          ))}
                        </React.Fragment>
                      }
                      placement={'top-start'}
                      TransitionComponent={Slide}
                      sx={{
                        '& .MuiTooltip-tooltip': {
                          maxWidth: isWindow() ? '400px' : '200px'
                        }
                      }}
                    >
                      <Box>
                        {OMIMValue.slice(0, 2).map((items: any, index: any) => {
                          return (
                            <TypographyA
                              sx={{
                                width: '100%',
                                maxWidth: 200,
                                lineHeight: '24px',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                cursor: 'pointer',
                                color: '#23527c',
                                mb: '4px'
                              }}
                              onClick={() => {
                                props.setCurrent(row)

                                props.setOMIMOpen(true)
                              }}
                              key={`${items.disease}_${index}`}
                            >
                              <Chip
                                label={`${
                                  items.genetic_mode ? items.genetic_mode : '.'
                                }`}
                                size="small"
                                sx={{
                                  height: 18,
                                  fontSize: '0.75rem'
                                }}
                              />

                              <span
                                style={{
                                  lineHeight: '24px'
                                }}
                              >{`${items.disease}`}</span>
                            </TypographyA>
                          )
                        })}

                        {/* {OMIMValue.length > 3 ? '...' : ''} */}
                      </Box>
                    </HtmlTooltip>
                  ) : (
                    <TypographyA>.</TypographyA>
                  )}
                </Stack>
              )
            } else if (row.OMIMArr && row.OMIMArr.length) {
              let OMIMValue =
                row.OMIMArr.map((items: any) => items?.omimData ?? [])
                  .flat()
                  .map((item: any) => {
                    const inheritances: string[] = []

                    if (
                      item &&
                      item.clinicalSynopsis &&
                      item.clinicalSynopsis.INHERITANCE &&
                      Array.isArray(item.clinicalSynopsis.INHERITANCE)
                    ) {
                      item.clinicalSynopsis.INHERITANCE.forEach((str: string) =>
                        inheritances.push(str.toLowerCase())
                      )
                    }
                    const inheritance = formatVariantInheritance(
                      Array.from([...new Set(inheritances)]).join(',')
                    )

                    return {
                      ...item,
                      inheritance
                    }
                  }) ?? []

              OMIMValue = unique(OMIMValue, 'phenoName')

              return (
                <Stack maxWidth={'100%'} spacing={1}>
                  {OMIMValue && OMIMValue.length ? (
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          {OMIMValue.map((item: any, index: any) => (
                            <TypographyA
                              sx={{
                                fontSize: '0.85rem',
                                lineHeight: '1rem',
                                maxWidth: isWindow()
                                  ? '400px !important'
                                  : '200px !important'
                              }}
                              key={`${item.phenoName}_${index}`}
                            >
                              {`(${
                                item.inheritance ? item.inheritance : '.'
                              })-${
                                i18n && i18n.language === 'zh'
                                  ? item.pheno_name_cn + '-'
                                  : ''
                              }${item.phenoName}`}
                            </TypographyA>
                          ))}
                        </React.Fragment>
                      }
                      placement={'top-start'}
                      TransitionComponent={Slide}
                      sx={{
                        '& .MuiTooltip-tooltip': {
                          maxWidth: isWindow() ? '400px' : '200px'
                        }
                      }}
                    >
                      <Box>
                        {OMIMValue.slice(0, 2).map((items: any, index: any) => {
                          return (
                            <TypographyA
                              sx={{
                                width: '100%',
                                maxWidth: 200,
                                lineHeight: '24px',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                cursor: 'pointer',
                                color: '#23527c',
                                mb: '4px'
                              }}
                              onClick={() => {
                                props.setCurrent(row)

                                props.setOMIMOpen(true)
                              }}
                              key={`${items.phenoMim}_${index}`}
                            >
                              <Chip
                                label={`${
                                  items.inheritance ? items.inheritance : '.'
                                }`}
                                size="small"
                                sx={{
                                  height: 18,
                                  fontSize: '0.75rem'
                                }}
                              />

                              <span
                                style={{
                                  lineHeight: '24px'
                                }}
                              >{`${
                                i18n && i18n.language === 'zh'
                                  ? items.pheno_name_cn + '-'
                                  : ''
                              }${items.phenoName}`}</span>
                            </TypographyA>
                          )
                        })}

                        {/* {OMIMValue.length > 3 ? '...' : ''} */}
                      </Box>
                    </HtmlTooltip>
                  ) : (
                    <TypographyA>.</TypographyA>
                  )}
                </Stack>
              )
            } else
              return (
                <Stack
                  maxWidth={'150px'}
                  width={'100%'}
                  marginTop={'12px'}
                  direction="column"
                  alignItems="start"
                >
                  <Tooltip
                    title={
                      <Box maxHeight={300} overflow="auto">
                        {omim_info?.map((item: any, index: any) => (
                          <TypographyA key={`${item.pheno_name_cn}_${index}`}>
                            {`(${item.inheritance ? item.inheritance : '.'})-${
                              item.pheno_name_cn
                            }`}
                          </TypographyA>
                        ))}
                      </Box>
                    }
                    placement={'top-start'}
                    TransitionComponent={Slide}
                    sx={{
                      '& .MuiTooltip-tooltip': {
                        maxWidth: isWindow() ? '400px' : '200px'
                      }
                    }}
                  >
                    <Box width={'100%'}>
                      {omim_info?.slice(0, 5).map((items: any, index: any) => {
                        return (
                          <TypographyA
                            sx={{
                              width: '100%',
                              maxWidth: 300,
                              lineHeight: '24px',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                              color:
                                bgcolor === 'rgb(109,56,149,0.8)' ||
                                bgcolor === 'rgb(107,148,200,0.8)' ||
                                bgcolor === 'rgba(229,38,35,0.8)'
                                  ? 'white'
                                  : '#23527c',
                              mb: '4px'
                            }}
                            onClick={() => {
                              props.setCurrent(row)

                              props.setOMIMOpen(true)
                            }}
                            key={`${items.pheno_name_cn}_${index}`}
                          >
                            <Chip
                              label={`${
                                items.inheritance ? items.inheritance : '.'
                              }`}
                              size="small"
                              sx={{
                                height: 18,
                                fontSize: '0.75rem'
                              }}
                            />

                            <span
                              style={{
                                lineHeight: '24px'
                              }}
                            >{`${items.pheno_name_cn}`}</span>
                          </TypographyA>
                        )
                      })}
                    </Box>
                  </Tooltip>
                </Stack>
              )
          },
          ...props.getColumnSearchProps('inheritance')
        },
        {
          dataIndex: 'scip_summary_priority',
          key: 'scip_summary_priority',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Tooltip title={'根据变异质量排序'}>
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('优先级')}
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
              >
                <TypographyA>{row?.scip_summary_priority}</TypographyA>
              </Stack>
            )
          }
        },
        {
          dataIndex: 'scip_summary_auto_result',
          key: 'scip_summary_auto_result',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Tooltip
                title={
                  <Box>
                    <Typography color={'white'} fontSize={12}>
                      质量:变异质量分级
                    </Typography>

                    <Typography color={'white'} fontSize={12}>
                      映射质量:变异质量评估参数，通常大于50
                    </Typography>

                    <Typography color={'white'} fontSize={12}>
                      深度比:目标区域与参考区域深度对比
                    </Typography>
                  </Box>
                }
              >
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {`${t('质量')}`}
                  </span>

                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {`${t('映射质量')}`}
                  </span>

                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('深度比')}
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                justifyContent={'center'}
              >
                <TypographyA>{row.scip_summary_auto_result}</TypographyA>

                <TypographyA>{row.scip_summary_mapping_quality}</TypographyA>

                <TypographyA>{row.scip_summary_depth_ratio}</TypographyA>
              </Stack>
            )
          }
        },

        {
          dataIndex: 'P_snvindel_nb',
          key: 'P_snvindel_nb',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} direction={'row'} alignItems="center">
              <Tooltip title={'区域内致病变异数量'}>
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    Pathogenic
                  </span>

                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    SNV/INDEL
                  </span>

                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    overlapped
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value: any, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
              >
                <Tooltip title={`${row.P_snvindel_nb}`} placement="top-start">
                  <TypographyA
                    sx={{
                      maxWidth: '100%',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {`${row.P_snvindel_nb}`}
                  </TypographyA>
                </Tooltip>
              </Stack>
            )
          }
        },
        {
          dataIndex: 'sv_count',
          key: 'sv_count',
          align: 'center',
          width: 100,
          ellipsis: true,
          sorter: false,
          filteredValue: [`${overlapRate}`],
          title: () => (
            <Stack
              maxWidth={'100%'}
              justifyContent="start"
              direction={'column'}
            >
              <Tooltip
                title={
                  'The overlap rate of different databases can be calculated, and the overlap rate can be adjusted personalized'
                }
              >
                <>
                  <Stack maxWidth={'100%'}>
                    <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                      {`${t('The overlap rate is over')}${
                        (overlapRate ?? 0.9) * 100
                      }%`}
                    </span>
                  </Stack>

                  <Stack maxWidth={'100%'}>
                    <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                      {`${t('Number of cases')}`}
                    </span>
                  </Stack>
                </>
              </Tooltip>
            </Stack>
          ),
          render: (value: any, row: any) => {
            const scip_gnomad_sv_data = row?.scip_gnomad_sv_data
            const scip_clinvar_sv_data = row?.scip_clinvar_sv_data
            const decipherCnvInfo =
              row?.tempCnvDecipherInfo?.decipherInfo?.decipherCnvInfo
            const decipherSyndromeInfo =
              row?.tempCnvDecipherInfo?.decipherInfo?.decipherSyndromeInfo
            const decipherPopulationInfo =
              row?.tempCnvDecipherInfo?.decipherInfo?.decipherPopulationInfo
            const decipherDgvInfo =
              row?.tempCnvDecipherInfo?.decipherInfo?.decipherDgvInfo

            // const gnomads =
            //   scip_gnomad_sv_data && Array.isArray(scip_gnomad_sv_data)
            //     ? [...scip_gnomad_sv_data].filter(
            //         (i) => i && i.overlap_rate && i.overlap_rate >= 0.9
            //       )
            //     : []
            // const gnomadscount = gnomads?.length
            // const clinvars =
            //   scip_clinvar_sv_data && Array.isArray(scip_clinvar_sv_data)
            //     ? [...scip_clinvar_sv_data].filter(
            //         (i) => i && i.overlap_rate && i.overlap_rate >= 0.9
            //       )
            //     : []
            // const clinvarscount = clinvars?.length
            const gnomad =
              decipherPopulationInfo && Array.isArray(decipherPopulationInfo)
                ? [...decipherPopulationInfo]
                    .filter(
                      (i) => switchVariantClass(i.variant_class) === row.sv_type
                    )
                    .map((i) => {
                      i.Coverage = calculateOverlapRate(
                        row.start,
                        row.end,
                        i.start,
                        i.end
                      )

                      return i
                    })
                    .filter((i) => i && i.Coverage && i.Coverage >= 0.9)
                : []

            const gnomadscount = gnomad?.length
            const clinvar =
              decipherSyndromeInfo && Array.isArray(decipherSyndromeInfo)
                ? [...decipherSyndromeInfo]
                    .filter(
                      (i) => switchVariantClass(i.variant_class) === row.sv_type
                    )
                    .map((i) => {
                      i.Coverage = calculateOverlapRate(
                        row.start,
                        row.end,
                        i.start,
                        i.end
                      )

                      return i
                    })
                    .filter((i) => i && i.Coverage && i.Coverage >= 0.9)
                : []

            const clinvarscount = clinvar?.length
            const decipher =
              decipherCnvInfo && Array.isArray(decipherCnvInfo)
                ? [...decipherCnvInfo]
                    .filter(
                      (i) => switchVariantClass(i.variant_class) === row.sv_type
                    )
                    .map((i) => {
                      i.Coverage = calculateOverlapRate(
                        row.start,
                        row.end,
                        i.start,
                        i.end
                      )

                      return i
                    })
                    .filter((i) => i && i.Coverage && i.Coverage >= 0.9)
                : []

            const deciphercount = decipher?.length
            const dgv =
              decipherDgvInfo && Array.isArray(decipherDgvInfo)
                ? [...decipherDgvInfo]
                    .filter(
                      (i) => switchVariantClass(i.variant_class) === row.sv_type
                    )
                    .map((i) => {
                      i.Coverage = calculateOverlapRate(
                        row.start,
                        row.end,
                        i.start,
                        i.end
                      )

                      return i
                    })
                    .filter((i) => i && i.Coverage && i.Coverage >= 0.9)
                : []

            const dgvcount = dgv?.length

            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                justifyContent={'center'}
                spacing={1}
                sx={{
                  cursor: 'pointer'
                }}
                onClick={() => {
                  props.setCurrent({
                    ...row,
                    gnomads: gnomad,
                    clinvars: clinvar,
                    decipherCnvInfos: decipher,
                    decipherDgvInfos: dgv
                  })

                  props.setCaseNumberInfoOpen &&
                    props.setCaseNumberInfoOpen(true)
                }}
              >
                <TypographyA>{`gnomad:${gnomadscount}`}</TypographyA>

                <TypographyA>{`clinvar:${clinvarscount}`}</TypographyA>

                <TypographyA>{`decipher:${deciphercount}`}</TypographyA>

                <TypographyA>{`dgv:${dgvcount}`}</TypographyA>
              </Stack>
            )
          },
          filters: [
            {
              text: '95%',
              value: '0.95'
            },
            {
              text: '90%',
              value: '0.9'
            },
            {
              text: '85%',
              value: '0.85'
            },
            {
              text: '80%',
              value: '0.8'
            },
            {
              text: '70%',
              value: '0.7'
            }
          ]
        },

        // {
        //   dataIndex: 'DDD_HI_percent',
        //   key: 'DDD_HI_percent',
        //   align: 'center',
        //   width: 100,
        //   ellipsis: true,
        //   sorter: false,
        //   title: () => (
        //     <Stack maxWidth={'100%'} direction={'row'} alignItems="center">
        //       <Stack maxWidth={'100%'}>
        //         <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
        //           {t('DDD HI')}
        //         </span>

        //         <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
        //           {t('LOEUF bin')}
        //         </span>

        //         <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
        //           {t('GnomAD pLI')}
        //         </span>
        //       </Stack>
        //     </Stack>
        //   ),
        //   render: (value:any, row: any) => {
        //     return (
        //       <Stack maxWidth={'100%'} direction="column" spacing={1}>
        //         <TypographyA
        //           sx={{
        //             width: '100%',
        //             maxWidth: 140,
        //             overflow: 'hidden',
        //             whiteSpace: 'nowrap',
        //             textOverflow: 'ellipsis'
        //           }}
        //         >
        //           {`${row.DDD_HI_percent}`}
        //         </TypographyA>

        //         <TypographyA
        //           sx={{
        //             width: '100%',
        //             maxWidth: 140,
        //             overflow: 'hidden',
        //             whiteSpace: 'nowrap',
        //             textOverflow: 'ellipsis'
        //           }}
        //         >
        //           {`${row.LOEUF_bin}`}
        //         </TypographyA>

        //         <TypographyA
        //           sx={{
        //             width: '100%',
        //             maxWidth: 140,
        //             overflow: 'hidden',
        //             whiteSpace: 'nowrap',
        //             textOverflow: 'ellipsis'
        //           }}
        //         >
        //           {`${
        //             row.GnomAD_pLI === '.' || row.GnomAD_pLI === 'NaN'
        //               ? '.'
        //               : (Number(row.GnomAD_pLI).toFixed(
        //                   4
        //                 ) as unknown as number) == 0
        //               ? 0
        //               : Number(row.GnomAD_pLI).toFixed(4)
        //           }`}
        //         </TypographyA>
        //       </Stack>
        //     )
        //   },
        //   ...props.getColumnSearchProps('scip_Geneinfo')
        // },

        // {
        //   dataIndex: 'clinvar_info',
        //   key: 'clinvar_info',
        //   align: 'center',
        //   width: 80,
        //   ellipsis: true,
        //   sorter: false,
        //   title: () => (
        //     <Stack maxWidth={'100%'} direction={'row'} alignItems="center">
        //       <Stack maxWidth={'100%'}>
        //         <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
        //           {t('clinvar Info')}
        //         </span>
        //       </Stack>
        //     </Stack>
        //   ),
        //   render: (value:any, row: any) => {
        //     const clinvar_info: any[] = row.clinvar_info ?? []

        //     return (
        //       <Stack maxWidth={'100%'} direction="column" spacing={1}>
        //         <TypographyA
        //           onClick={(e) => {
        //             if (clinvar_info.length) {
        //               props.setCurrent(row)

        //               props.handleMenuClick(e, 'clinvar_info')
        //             }
        //           }}
        //           sx={{
        //             cursor: 'pointer'
        //           }}
        //         >
        //           {clinvar_info.length}
        //         </TypographyA>
        //       </Stack>
        //     )
        //   }
        // },
        {
          dataIndex: 'scip_clingen_sv_data',
          key: 'scip_clingen_sv_data',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Tooltip title={'clingen数据库特殊区域描述'}>
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {`${t('clingen')}`}
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value: any, row: any) => {
            const scip_clingen_sv_data: any[] = row.scip_clingen_sv_data ?? []
            const scip_clinical_genome_data: any[] =
              row.scip_clinical_genome_data ?? []

            return (
              <Tooltip
                title={scip_clinical_genome_data
                  .map((i) => `${i.dosageId}(${i.hgncId})`)
                  .join(';')}
              >
                <TypographyA
                  onClick={(e) => {
                    props.setCurrent(row)

                    // props.handleMenuClick(e, 'scip_clingen')

                    props.setClingenOpen(true)
                  }}
                  sx={{
                    maxWidth: 100,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    cursor: 'pointer'
                  }}
                >
                  {scip_clinical_genome_data
                    .map((i) => `${i.dosageId}(${i.hgncId})`)
                    .join(';')}
                </TypographyA>
              </Tooltip>
            )
          },
          ...props.getColumnSearchProps('scip_Clingen')
        }
      ]
    }
  }, [props, overlapRate])

  React.useImperativeHandle(ref, () => ({
    column,
    overlapRate
  }))

  return <></>
})

export default columns2CNV
